export const CUSTOM_LIST_MAX_ENTRIES = 500

export function countPhoneEntries(text) {
  return String(text || '').split(/[\n\t,;、，；]/).filter(item => item.trim()).length
}

const excludedReasons = {
  invalid_format: '格式錯誤或非 09 開頭十碼',
  line_unbound: '未綁定 LINE',
  line_blocked: '已封鎖官方帳號',
  sms_bound_not_selected: '已綁定 LINE（未勾選此對象）',
  sms_unbound_not_selected: '未綁定 LINE（未勾選此對象）',
  manual: '手動取消'
}

export function excludedReasonText(reason) {
  return excludedReasons[reason] || reason
}
